import Vue from "vue";
import VueRouter from "vue-router";
import router from "./router";
import filtros from "@/config/filters";
import DashboardPlugin from "./material-dashboard";
import VueMaterial from "vue-material";
import vueHeadful from "vue-headful";
import App from "./App.vue";
import Chartist from "chartist";
import store from "./config/vuex/store";
import axios from "axios";
import VueExcelXlsx from "vue-excel-xlsx";
import { ExportTxt } from "export-txt";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueTheMask from "vue-the-mask";
import money from "vuejs-money";

Vue.use(money);
Vue.use(VueTheMask);
Vue.component("vue-headful", vueHeadful);
Vue.use(VueMaterial);
Vue.use(ExportTxt, { name: "$exportTxt" });
Vue.use(VueExcelXlsx);
Vue.use(Loading);

Vue.material.locale.dateFormat = "dd/MM/yyyy";
(Vue.material.locale.cancelButton = "Fechar"),
  (Vue.material.locale.days = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sabado",
  ]),
  (Vue.material.locale.shortDays = [
    "Don",
    "Seg",
    "Ter",
    "Qua",
    "Qui",
    "Sex",
    "Sab",
  ]),
  (Vue.material.locale.shorterDays = ["D", "S", "T", "Q", "Q", "S", "S"]),
  (Vue.material.locale.months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ]),
  (Vue.material.locale.shortMonths = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ]),
  (Vue.material.locale.shorterMonths = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "Ju",
    "Ju",
    "A",
    "Se",
    "O",
    "N",
    "D",
  ]),
  (Vue.material.locale.firstDayOfAWeek = 1);

Vue.prototype.$urlAPI = "https://laravel.cartaopop.com.br/api/"; //'https://www.serverpopcard.com/api/';
Vue.prototype.$http = axios;

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

// global library setup
Vue.prototype.$Chartist = Chartist;

Vue.directive("focus", {
  // Quando o elemento vinculado é inserido no DOM...
  inserted: function(el) {
    // Coloque o foco no elemento
    el.focus();
  },
});

export default {};

new Vue({
  store,
  el: "#app",
  render: (h) => h(App),
  router,
  filtros,
});
